import { Appointment } from '@type';
import { updateArrayWithElements } from '@utils';

import { initialState, STORE_NAME } from './appointments-store.constant';
import { GetType, SetType } from './appointments-store.type';

export const setAppointments = (set: SetType) => {
  return (appointments: Appointment[]) => {
    set({ appointments }, false, `${STORE_NAME}-SET_APPOINTMENT`);
    return appointments;
  };
};

export const addAppointment = (set: SetType, get: GetType) => {
  return (appointment: Appointment) => {
    const appointments = get().appointments;
    const newAppointments = updateArrayWithElements(appointment, appointments);
    set(
      { appointments: newAppointments },
      false,
      `${STORE_NAME}-ADD_APPOINTMENT`
    );
    return newAppointments;
  };
};

export const removeAppointment = (set: SetType, get: GetType) => {
  return (appointment: Appointment) => {
    const appointments = get().appointments;
    const newAppointments = updateArrayWithElements(
      appointment,
      appointments,
      true
    );
    set(
      { appointments: newAppointments },
      false,
      `${STORE_NAME}-REMOVE_APPOINTMENT`
    );
    return newAppointments;
  };
};

export const resetAppointments = (set: SetType) => () =>
  set(
    { appointments: initialState.appointments },
    false,
    `${STORE_NAME}-RESET_APPOINTMENTS`
  );
